import axios from "axios";
import { useEncryptService, useStorageManager } from "../shared/hooks";
import { END_POINTS } from "../shared";
import store from "../store/store";
import { authActions } from "../store/authSlice";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

const { doEncrypt } = useEncryptService();
const { getCookie } = useStorageManager();

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (!config.headers.Authorization && token) {
      config.headers.Authorization = `Bearer ${token.replace(/"/g, "")}`;
    }
    const ignoredApi = () => {
      const ignoreApiList = [];
      ignoreApiList.push(END_POINTS.MASTER_TEMPLATE_UPLOAD);
      ignoreApiList.push("/authentication/org-pic-upload");
      ignoreApiList.push("/authentication/user-pic-upload");
      ignoreApiList.push(END_POINTS.SSH_UPLOAD);
      ignoreApiList.push(END_POINTS.RULEMANAGEMENT_TEST);
      ignoreApiList.push(END_POINTS.RULE_MANAGEMENT_DEPLOY);
      ignoreApiList.push(END_POINTS.FILECHUNKS);
      ignoreApiList.push(END_POINTS.SSH_FIELD);
      ignoreApiList.push(END_POINTS.API_FIELD);
      ignoreApiList.push(END_POINTS.DOWNLOAD_SAMPLE_FILE);
      ignoreApiList.push(END_POINTS.AUTH);
      ignoreApiList.push(END_POINTS.LOGIN);
      ignoreApiList.push(END_POINTS.REFRESH_TOKEN);
      ignoreApiList.push(END_POINTS.LOGOUT);
      ignoreApiList.push(END_POINTS.REGISTER);
      ignoreApiList.push(END_POINTS.CHANGE_PASSWORD);
      ignoreApiList.push(END_POINTS.RESET);
      ignoreApiList.push(END_POINTS.PASSWORD_CONFIRMATION);
      ignoreApiList.push(END_POINTS.SSO_LOGIN);
      ignoreApiList.push(END_POINTS.APEXIQ_INTEGRATION);
      ignoreApiList.push(END_POINTS.EDIT_ORG_IMAGE);
      ignoreApiList.push(END_POINTS.EDIT_USER_IMAGE);
      ignoreApiList.push(END_POINTS.USER_DETAILS);
      ignoreApiList.push(END_POINTS.USER_PERMISSION);
      ignoreApiList.push(END_POINTS.GET_USER_IMAGE);
      ignoreApiList.push(END_POINTS.RESET_PASS_TOKEN_API);
      ignoreApiList.push(END_POINTS.ACTIVATE_REGISTRATION);
      ignoreApiList.push(END_POINTS.AUTHENTICATE_SINGLE_SIGNIN);
      ignoreApiList.push(END_POINTS.RESEND_EMAIL);
      ignoreApiList.push(END_POINTS.INVITE_SUPER_ADMIN);
      ignoreApiList.push(END_POINTS.GET_ORG_IMAGE);
      ignoreApiList.push(END_POINTS.PROFILE_SETUP_GET_LEVELS);
      ignoreApiList.push(END_POINTS.MUTE_NOTIFICATION);
      ignoreApiList.push(END_POINTS.Asset_SUMMARY_DATA);
      ignoreApiList.push(END_POINTS.Asset_SUMMARY_REPORT);
      ignoreApiList.push(END_POINTS.DELETE_ORG);
      //ignoreApiList.push(END_POINTS.RESCAN);
      ignoreApiList.push(END_POINTS.DASHBOARD_TOP_CVES);
      ignoreApiList.push(END_POINTS.Asset_Compliance_Report);
      ignoreApiList.push(END_POINTS.CREATE_PASSWORD);
      ignoreApiList.push(END_POINTS.RESET_PASS_TOKEN_API);
      ignoreApiList.push(END_POINTS.CREATE_PASSWORD);
      ignoreApiList.push(END_POINTS.TOKEN_VALIDATION);
      ignoreApiList.push(END_POINTS.FILE_UPLOAD_PROCESS);
      ignoreApiList.push(END_POINTS.REPORT_DOWNLOAD);
      ignoreApiList.push(END_POINTS.RESCAN_RECOMMISSION);
      //ignoreApiList.push(END_POINTS.RE_SCAN_CRED);
      ignoreApiList.push(END_POINTS.REPORT_UPDATE_DELETE);
      ignoreApiList.push(END_POINTS.CREDENTIAL_MGMT);
      ignoreApiList.push(END_POINTS.RE_SCAN_CRED);
      ignoreApiList.push(END_POINTS.ASSET_VIEWSUMMARY);
      ignoreApiList.push(END_POINTS.MY_SCAN_DETAILS);
      ignoreApiList.push(END_POINTS.WMI_ASSET_DETAILS);
      return ignoreApiList;
    };

    if (
      config.data &&
      ["post", "put", "patch"].includes(config.method?.toLowerCase() || "")
    ) {
      try {
        // const jsonData = JSON.stringify(config.data);
        // config.data = { encryptedData: doEncrypt(jsonData) };
        const encryptionAllowed = getCookie("encryptionAllowed") === "true";
        const ignoredEndpoints = ignoredApi();
        console.log(
          "endpoints exclueded:",
          config.url,
          !ignoredEndpoints.some((endpoint) => (config.url ?? "").startsWith(endpoint))
        );
        //|| config.url === "securityscan/rescan-with-cred")
        console.log("config.url:", config.url === "securityscan/rescan-with-cred");
        console.log("encryptionAllowed:", encryptionAllowed);
        if (encryptionAllowed && (!ignoredEndpoints.some((endpoint) => (config.url ?? "").startsWith(endpoint)))) {
          console.log("Encrypting data for:", config.url);
          const jsonData = JSON.stringify(config.data);
          config.data = { payload: doEncrypt(jsonData) };
        }
      } catch (error) {
        toast.error("Encryption failed");
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      (error.response?.status === 401 ||
        error.response?.data?.status === 401) &&
      error.config.url != "secure-auth/login"
    ) {
      // If a role-based logout is already in progress (from event-manager),
      // skip this handler to avoid racing with the role logout redirect
      // which would cause the "Account Expired" popup to flash.
      if ((window as any).__roleLogoutInProgress) {
        return Promise.reject(error);
      }

      console.log("Unauthorized! Dispatching logout...");

      store.dispatch(authActions.logout());
      localStorage.clear();

      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
